import { FC } from 'react';
import { AllieDataGrid } from '../../../components/DataGrid';
import type { DatagridContainerProps } from './DataContainer.types';

const DEFAULT_DATAGRID_FETCH_SIZE = 10;

export type DatagridContainerDesktopProps = Omit<
  DatagridContainerProps,
  'renderItem' | 'fetchStrategy'
>

export const AllieDataContainerDesktop: FC<DatagridContainerDesktopProps> = ({
  limit = DEFAULT_DATAGRID_FETCH_SIZE,
  ...props
}) => <AllieDataGrid limit={limit} {...props} />;
